import { FrameConnector, print } from "@tradetrust-tt/decentralized-renderer-react-components";
import "../css/custom.css";
import { useCallback, useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Spinner } from "react-bootstrap";
import { utils } from "@tradetrust-tt/tradetrust";

const DocumentViewer = forwardRef((props, ref) => {
    const [height, setHeight] = useState(50);
	const width = "80%";
	const [toFrame, setToFrame] = useState();
	const originalDocument = props.renderDoc;
	var isAcraOADoc = utils.isSignedWrappedV2Document(originalDocument) || utils.isSignedWrappedV3Document(originalDocument);
	var unwrappedDocument = isAcraOADoc ? utils.getDocumentData(originalDocument) : originalDocument;
	const [isLoadingRenderer, setIsLoadingRenderer] = useState(true);
    const forwardedRef = ref;

	const onConnected = useCallback((frame) => {
		setToFrame(() => frame);
	}, []);

	function handleDispatch(action) {
        console.log(action);
		setIsLoadingRenderer(false);
		if (action.type === "UPDATE_HEIGHT") {
			setHeight(action.payload + 20);
		}
		if (action.type === "OBFUSCATE") {
			alert("Privacy filter not available in preview mode");
		}
	}

	useEffect(
		() => {
			if (toFrame && originalDocument) {
				console.log(originalDocument);
				isAcraOADoc = utils.isSignedWrappedV2Document(originalDocument) || utils.isSignedWrappedV3Document(originalDocument);
				unwrappedDocument = isAcraOADoc ? utils.getDocumentData(originalDocument) : originalDocument;
				console.log(unwrappedDocument);
				toFrame({
					type: "RENDER_DOCUMENT",
					payload: {
						document: unwrappedDocument,
						rawDocument: originalDocument,
					},
				});
			}
		},
		// eslint-disable-next-line
		[toFrame, unwrappedDocument]
	);

    useImperativeHandle(forwardedRef, () => ({
        print() {
            toFrame({
                type: "PRINT"
            })
        }
    }));

	return (
		<div ref={ref}>
			{isLoadingRenderer && (
				<div style={{marginLeft: "8%"}}>
					<div className="doc-loader-big">
						<Spinner
							animation="border"
							role="status"
							style={{ width: "4rem", height: "4rem" }}
						>
							<span className="visually-hidden">Loading...</span>
						</Spinner>
					</div>
					<p>Please wait while we verify your document.</p>
				</div>
			)}
			<FrameConnector
				source={unwrappedDocument.$template
						? unwrappedDocument.$template.url
						: unwrappedDocument.renderMethod.id}
				onConnected={onConnected}
				style={{ height, width }}
				dispatch={handleDispatch}
				className="block m-auto w-full"
			/>
		</div>
	);
});

export default DocumentViewer;
